import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Dropdown, Option, useId } from "@fluentui/react-components";
import FormFieldLabel from "components/FormFieldLabel/FormFieldLabel";
import {
  ErrorMessageContainer,
  FormFieldContainer,
  StyledErrorMessage,
} from "components/styled";

type OptionItem = {
  value: string;
  label: string;
};

type Props = {
  name: string;
  label: string;
  form: UseFormReturn<any>;
  options: OptionItem[];
  required?: boolean;
  disabled?: boolean;
};

const HookFormSelectField = ({
  name,
  label,
  form,
  options,
  required = false,
  disabled = false,
}: Props) => {
  const {
    register,
    setValue,
    formState: { errors },
    watch,
  } = form;

  const id = useId(name);
  const value = watch(name) || "";
  const error = errors[name]?.message as string;

  // Register the field
  register(name);
  const handleChange = (_event: any, data: any) => {
    setValue(name, data.optionValue, { shouldValidate: true });
  };

  return (
    <FormFieldContainer>
      <FormFieldLabel label={label} required={required} />
      <Dropdown
        id={id}
        value={options.find((opt) => opt.value === value)?.label || ""}
        disabled={disabled}
        onOptionSelect={handleChange}
      >
        {options.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Dropdown>
      <ErrorMessageContainer>
        <StyledErrorMessage>{error}</StyledErrorMessage>
      </ErrorMessageContainer>
    </FormFieldContainer>
  );
};

export default HookFormSelectField;
